import script from "./ComDuplicatesWarning.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComDuplicatesWarning.vue?vue&type=script&setup=true&lang=ts"

import "./ComDuplicatesWarning.vue?vue&type=style&index=0&id=354a7434&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-354a7434"]])

export default __exports__